import { Component, OnDestroy } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TileSelectService } from '../../services';
import { ExportService } from '../state/export.service';

@Component({
    selector: 'export-button',
    templateUrl: './export-button.component.html',
    styleUrls: ['./export-button.component.scss']
})
export class ExportButtonComponent implements OnDestroy {
    selectedCreatives: number;
    isExporting$: Observable<boolean>;
    unsubscribe$ = new Subject<void>();

    constructor(
        private tileSelectService: TileSelectService,
        private exportCreativeService: ExportService
    ) {
        this.tileSelectService.selection$.pipe(takeUntil(this.unsubscribe$)).subscribe(creatives => {
            this.selectedCreatives = creatives.filter(c => c.design).length;
        });

        this.isExporting$ = this.exportCreativeService.isExporting$;
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
